export interface GeolocationCoordinates {
  latitude: number
  longitude: number
  accuracy: number
  altitude: number | null
  altitudeAccuracy: number | null
  heading: number | null
  speed: number | null
}

export interface GeolocationPosition {
  timestamp: number
  coords: GeolocationCoordinates
}

export interface IPositionMeasurement {
  timestamp: number
  latitude: number
  longitude: number
  accuracy: number
}

/** Normalized player GPS for portal listing gates and catalog geo. */
export function getPlayerPositionCoordinates(
  position: IPositionMeasurement | null | undefined
): { latitude: number | null, longitude: number | null } {
  if (position == null) {
    return { latitude: null, longitude: null }
  }
  const { latitude, longitude } = position
  if (
    typeof latitude !== 'number'
    || typeof longitude !== 'number'
    || !Number.isFinite(latitude)
    || !Number.isFinite(longitude)
  ) {
    return { latitude: null, longitude: null }
  }
  return { latitude, longitude }
}
